import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ccaa_actions } from "../../store/ccaa_slice";
import { FileUploader } from "react-drag-drop-files";
import { storage } from "../../firebase";
import {
  ref,
  getDownloadURL,
  uploadBytesResumable,
  listAll,
  deleteObject
} from "firebase/storage";
import { Radio } from "@chakra-ui/react";

import { Typography, Alert, Progress } from "antd";

import { Text } from "@chakra-ui/react";

const { Title } = Typography;

function Summary_Effectiveness() {
  //redux functions
  const dispatch = useDispatch();
  const organization_name_store = useSelector(
    (state) => state.ccaa.organization_name_store
  );

  const summary_effectiveness_store = useSelector(
    (state) => state.ccaa.summary_effectiveness_store
  );

  const summary_effectiveness_checkboxes = useSelector(
    (state) => state.ccaa.summary_effectiveness_checkboxes
  );

  //file constants
  const summary_effectiveness_default_values = {
    organization_name: organization_name_store,
    methods_effective_monitoring: "",
    map_file: "",
    monitoring_results_summary: "",
    summary_tracking_sheet_file: "",
    adaptive_management_triggered: [],
    adaptive_management_actions: "",
    supplemental_effectiveness_monitoring: ""
  };

  const summary_effectiveness_default_checkboxes = {
    adaptive_management_actions_yes: false,
    adaptive_management_actions_no: false
  };

  const [summary_effectiveness_values, setSummaryEffectivenessValues] =
    React.useState(summary_effectiveness_default_values);
  const [
    summary_effectiveness_checkbox_values,
    setSummaryEffectivenessCheckboxes
  ] = React.useState(summary_effectiveness_default_checkboxes);
  const summary_effectiveness_files = useSelector(
    (state) => state.ccaa.summary_effectiveness_files
  );

  const text_input_width = window.innerWidth * 0.5;
  const text_input_height = window.innerHeight * 0.05;

  const [fileUploadProgress, setFileUploadProgress] = React.useState({
    summary_tracking_sheet_file: 0,
    map_file: 0
  });
  const [fileUploadStatus, setFileUploadStatus] = React.useState({
    summary_tracking_sheet_file: false,
    map_file: false
  });
  const [fileNames, setFileNames] = React.useState({});
  const [updateFileNames, setUpdateFileNames] = React.useState(0);

  //functions

  const handleRadioBox = (e) => {
    const { name, value } = e.target;
    setSummaryEffectivenessValues({
      ...summary_effectiveness_values,
      [name]: []
    });
    //add the new value
    setSummaryEffectivenessValues({
      ...summary_effectiveness_values,
      [name]: [value]
    });
    if (value === "adaptive_management_actions_yes") {
      dispatch(
        ccaa_actions.set_summary_effectiveness_radio({
          name,
          value,
          checked: true
        })
      );
      dispatch(
        ccaa_actions.set_summary_effectiveness_radio({
          name,
          value: "adaptive_management_actions_no",
          checked: false
        })
      );
    } else if (value === "adaptive_management_actions_no") {
      dispatch(
        ccaa_actions.set_summary_effectiveness_radio({
          name,
          value,
          checked: true
        })
      );
      dispatch(
        ccaa_actions.set_summary_effectiveness_radio({
          name,
          value: "adaptive_management_actions_yes",
          checked: false
        })
      );
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (Array.isArray(summary_effectiveness_values[name])) {
      if (!summary_effectiveness_values[name].includes(value)) {
        setSummaryEffectivenessValues({
          ...summary_effectiveness_values,
          [name]: [...summary_effectiveness_values[name], value]
        });
        dispatch(
          ccaa_actions.set_summary_effectiveness_checkboxes({ name, value })
        );
      } else {
        setSummaryEffectivenessValues({
          ...summary_effectiveness_values,
          [name]: summary_effectiveness_values[name].filter(
            (item) => item !== value
          )
        });
        dispatch(
          ccaa_actions.set_summary_effectiveness_checkboxes({ name, value })
        );
      }
    } else {
      setSummaryEffectivenessValues({
        ...summary_effectiveness_values,
        [name]: value
      });
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    dispatch(
      ccaa_actions.set_summary_effectiveness(summary_effectiveness_values)
    );
  };

  useEffect(() => {
    dispatch(
      ccaa_actions.set_summary_effectiveness(summary_effectiveness_values)
    );
  }, [summary_effectiveness_values]);

  useEffect(() => {
    setSummaryEffectivenessCheckboxes(summary_effectiveness_checkboxes);
  }, [summary_effectiveness_checkboxes]);

  useEffect(() => {
    //set organization name
    setSummaryEffectivenessValues({
      ...summary_effectiveness_values,
      organization_name: organization_name_store
    });
    setSummaryEffectivenessValues(summary_effectiveness_store);
    setFileNames({
      map_file: [],
      summary_tracking_sheet_file: []
    });
    handleFirebaseGetAllFiles("map_file");
    handleFirebaseGetAllFiles("summary_tracking_sheet_file");
    setUpdateFileNames(updateFileNames + 1);
  }, []);

  useEffect(() => {
    setUpdateFileNames(updateFileNames + 1);
  }, [fileNames]);

  const handleFirebaseUpload = async (e, fileType) => {
    //e.preventDefault();
    if (e !== null) {
      const uploadFileName = e.name;
      const storageRef = ref(
        storage,
        `${organization_name_store}/${fileType}/${uploadFileName}`
      );
      const uploadTask = uploadBytesResumable(storageRef, e);
      setFileUploadStatus({
        ...fileUploadStatus,
        [fileType]: true
      });
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setFileUploadProgress({
            ...fileUploadProgress,
            [fileType]: Math.round(progress)
          });
          switch (snapshot.state) {
            case "paused":
              break;
            case "running":
              break;
            default:
          }
        },
        (error) => {
          switch (error.code) {
            case "storage/unauthorized":
              // User doesn't have permission to access the object
              break;
            case "storage/canceled":
              // User canceled the upload
              break;
            case "storage/unknown":
              // Unknown error occurred, inspect error.serverResponse
              break;
            default:
          }
        },
        () => {
          dispatch(
            ccaa_actions.set_summary_effectiveness_files({
              fileType,
              fileName: uploadFileName
            })
          );
          setFileUploadStatus(false);
          setUpdateFileNames(updateFileNames + 1);
        }
      );
    }
  };

  const handleFirebaseDeleteFile = async (fileType, fileName) => {
    const fileRef = ref(
      storage,
      `${organization_name_store}/${fileType}/${fileName}`
    );
    await deleteObject(fileRef);
    dispatch(
      ccaa_actions.remove_summary_effectiveness_files({ fileType, fileName })
    );
  };

  const handleFirebaseGetAllFiles = async (fileType) => {
    const listRef = ref(storage, `${organization_name_store}/${fileType}`);
    const fileList = await listAll(listRef).then((res) => {
      res.items.forEach((item) => {
        dispatch(
          ccaa_actions.set_summary_effectiveness_files({
            fileType,
            fileName: item.name
          })
        );
      });
    });
  };

  useEffect(() => {
    setFileNames(summary_effectiveness_files);
  }, [summary_effectiveness_files]);

  return (
    <>
      <div className="container">
        <Title level={3}>Summary of Effectiveness Monitoring</Title>
        <div className="mt-2 mb-2">
          <label type="text">
            Provide a concise summary of effectiveness monitoring conducted in
            2024.
          </label>
        </div>
        <div className="mt-2 mb-2">
          <Alert
            message="Please note your responses are saved automatically"
            type="info"
            showIcon
          />
        </div>
        <form onSubmit={handleFormSubmit}>
          <div className="p-4 border-1 border-dark rounded-3 border-background">
            <div className="row">
              <div className="col-flex-util">
                <Title level={4}>
                  Describe the method(s) used for effectiveness monitoring,
                  where monitoring was conducted, and if applicable, notes
                  regarding implementation of monitoring activities.
                </Title>
                <div>
                  <textarea
                    rows={10}
                    width={text_input_width}
                    height={text_input_height}
                    type="text"
                    className="form-control"
                    id="methods_effective_monitoring"
                    placeholder=""
                    name="methods_effective_monitoring"
                    defaultValue={
                      summary_effectiveness_store.methods_effective_monitoring
                        ? summary_effectiveness_store.methods_effective_monitoring
                        : ""
                    }
                    onBlur={handleInputChange}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4 p-4 border-1 border-dark rounded-3 border-background">
            <div className="row">
              <div className="col-flex-util">
                <Title level={4}>
                  Provide a map displaying the general location of where
                  monitoring was conducted as an attachment.
                </Title>
                <div>
                  <FileUploader
                    handleChange={(e) => handleFirebaseUpload(e, "map_file")}
                    name="map_file"
                  />
                </div>
                <div>
                  {fileUploadStatus["map_file"] ? (
                    <Progress
                      percent={fileUploadProgress["map_file"]}
                      status={fileUploadStatus}
                    />
                  ) : (
                    ""
                  )}
                </div>
                <div className="mt-2 file-component">
                  <Text className="mb-2">Uploaded Files</Text>
                  {updateFileNames && fileNames["map_file"].length > 0
                    ? fileNames["map_file"].map((file, index) => (
                        <div className="mt-2 row" key={index}>
                          <Text className="col-10">{file}</Text>
                          <button
                            className="col-2 btn btn-sm btn-danger"
                            onClick={(e) =>
                              handleFirebaseDeleteFile("map_file", file)
                            }
                          >
                            Delete
                          </button>
                        </div>
                      ))
                    : null}
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4 p-4 border-1 border-dark rounded-3 border-background">
            <div className="row">
              <div className="col-flex-util">
                <Title level={4}>
                  Summarize your monitoring results: milkweed stems per plot,
                  percent cover of nectar plants (if applicable), unexpected
                  results, lessons learned, and recommendations for future
                  implementation or monitoring.
                </Title>
                <div>
                  <textarea
                    rows={10}
                    width={text_input_width}
                    height={text_input_height}
                    type="text"
                    className="form-control"
                    id="monitoring_results_summary"
                    placeholder=""
                    name="monitoring_results_summary"
                    defaultValue={
                      summary_effectiveness_store.monitoring_results_summary
                        ? summary_effectiveness_store.monitoring_results_summary
                        : ""
                    }
                    onBlur={handleInputChange}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4 p-4 border-1 border-dark rounded-3 border-background">
            <div className="row">
              <div className="col-flex-util">
                <Title level={4}>
                  Upload your Effectiveness Monitoring document, other
                  supporting tables, photos, and/or figures as attachments.
                </Title>
                <Text>
                  {" "}
                  The Effectiveness Monitoring Template is available on the
                  Monarch CCAA Toolkit
                </Text>
                <div>
                  <Text>
                    {" "}
                    Link:{" "}
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://rightofway.erc.uic.edu/working-group-access/monarchccaatoolkit"
                    >
                      Effectiveness Monitoring Template
                    </a>
                  </Text>
                </div>
                <div>
                  <FileUploader
                    handleChange={(e) =>
                      handleFirebaseUpload(e, "summary_tracking_sheet_file")
                    }
                    name="summary_tracking_sheet_file"
                  />
                </div>
                <div>
                  {fileUploadStatus["summary_tracking_sheet_file"] ? (
                    <Progress
                      percent={
                        fileUploadProgress["summary_tracking_sheet_file"]
                      }
                      status={fileUploadStatus}
                    />
                  ) : (
                    ""
                  )}
                </div>
                <div className="mt-2 file-component">
                  <Text className="mb-2">Uploaded Files</Text>
                  {updateFileNames &&
                  fileNames["summary_tracking_sheet_file"].length > 0
                    ? fileNames["summary_tracking_sheet_file"].map(
                        (file, index) => (
                          <div className="mt-2 row" key={index}>
                            <Text className="col-10">{file}</Text>
                            <button
                              className="col-2 btn btn-sm btn-danger"
                              onClick={(e) =>
                                handleFirebaseDeleteFile(
                                  "summary_tracking_sheet_file",
                                  file
                                )
                              }
                            >
                              Delete
                            </button>
                          </div>
                        )
                      )
                    : null}
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4 p-4 border-1 border-dark rounded-3 border-background">
            <div className="row">
              <div className="col-flex-util">
                <Title level={4}>Was adaptive management triggered?</Title>
                <div className="col-flex-util">
                  <div className="col-md-2">
                    <Radio
                      name="adaptive_management_triggered"
                      value="adaptive_management_actions_yes"
                      onChange={(e) => handleRadioBox(e)}
                      isChecked={
                        summary_effectiveness_checkbox_values.adaptive_management_actions_yes
                          ? summary_effectiveness_checkbox_values.adaptive_management_actions_yes
                          : false
                      }
                    >
                      Yes
                    </Radio>
                  </div>
                  <div className="col-md-2">
                    <Radio
                      name="adaptive_management_triggered"
                      value="adaptive_management_actions_no"
                      onChange={(e) => handleRadioBox(e)}
                      isChecked={
                        summary_effectiveness_checkbox_values.adaptive_management_actions_no
                          ? summary_effectiveness_checkbox_values.adaptive_management_actions_no
                          : false
                      }
                    >
                      No
                    </Radio>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4 p-4 border-1 border-dark rounded-3 border-background">
            <div className="row">
              <div className="col-flex-util">
                <Title level={4}>
                  Describe any adaptive management actions you anticipate
                  implementing, if applicable.
                </Title>
                <div>
                  <textarea
                    rows={10}
                    width={text_input_width}
                    height={text_input_height}
                    type="text"
                    className="form-control"
                    id="adaptive_management_actions"
                    placeholder=""
                    name="adaptive_management_actions"
                    defaultValue={
                      summary_effectiveness_store.adaptive_management_actions
                        ? summary_effectiveness_store.adaptive_management_actions
                        : ""
                    }
                    onBlur={handleInputChange}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4 mb-4 p-4 border-1 border-dark rounded-3 border-background">
            <div className="row">
              <div className="col-flex-util">
                <Title level={4}>
                  Describe any supplemental effectiveness monitoring implemented
                  and any lessons learned or results that will inform future
                  implementation.
                </Title>
                <div>
                  <textarea
                    rows={10}
                    width={text_input_width}
                    height={text_input_height}
                    type="text"
                    className="form-control"
                    id="supplemental_effectiveness_monitoring"
                    placeholder=""
                    name="supplemental_effectiveness_monitoring"
                    defaultValue={
                      summary_effectiveness_store.supplemental_effectiveness_monitoring
                        ? summary_effectiveness_store.supplemental_effectiveness_monitoring
                        : ""
                    }
                    onBlur={handleInputChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default Summary_Effectiveness;
